<template>
    <div class="container-fluid" style="max-height: 100%; height: 100%; overflow: auto; padding-top: 0px; padding-bottom:60px;">
        <div class="row justify-content-center">
            <div class="container-fluid">
                <div class="row d-flex align-items-center flex-column justify-content-center">
                    <div class="col-xl-6 text-center">
                        <h1>
                            <br>
                            <br>
                            Welcome {{ currentAccount.firstname }}
                            <br>
                            Please select up to 3 layouts you like
                        </h1>
                    </div>
                </div>
            </div>
            <photo-book-layout-template-selection></photo-book-layout-template-selection>
        </div>
    </div>
    </template>
    <script>
    import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
    import PhotoBookLayoutTemplateSelection from '../../../cscomponents/swodt/PhotoBookLayoutTemplateSelection';
      import { Tooltip } from 'element-ui'
      export default {
        name: 's08',
        components: {
          [Tooltip.name]: Tooltip,
          PhotoBookLayoutTemplateSelection,
        },
        methods: {
            allDataValidated: function () {
                if(this.currentPhotoBook.selected_book_layouts.length > 0){
                    this.$emit('allowProceed');
                }
                else{
                    this.$emit('denyProceed');
                } 
            },
        },
        computed: {
            ...mapGetters({
                currentAccount: 'currentAccount',
                currentPhotoBook: 'currentPhotoBook',
            }),
        },
        watch: {
            currentPhotoBook: {
                handler:function (newItem) {
                    this.allDataValidated();
                },
                deep: true
            },
        },
        mounted(){
            this.$emit('denyProceed');
            this.allDataValidated();
        },
      };
    </script>